export default __webpack_public_path__ + "images/building.v-12c9c60d2d2bff0378239767985cb069.svg";